import { bool, func } from "prop-types";
import React from "react";
import getImage from "../../../utils/utils";
import { StyledBurger } from "./Hamburger.styled";

const Burger = ({ open, setOpen }) => {
  return (
    <StyledBurger open={open} onClick={() => setOpen(!open)}>
      <img src={getImage("hamburger")} alt={"hamburger"} />
    </StyledBurger>
  );
};

Burger.propTypes = {
  open: bool.isRequired,
  setOpen: func.isRequired
};

export default Burger;
